export const headerStyles = {
  mainContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 25px',
    width: '100%',
    boxSizing: 'border-box'
  },
  headerLeft: { 
    display: 'flex', 
    alignItems: 'center', 
    gap: '15px' 
  },
  headerLogoImage: { 
    width: '30px', 
    height: '30px', 
    objectFit: 'contain' 
  },
  title: { 
    fontSize: '1.4rem', 
    margin: 0, 
    fontWeight: '700', 
    textAlign: 'left' 
  },
  subtitle: { 
    fontSize: '0.85rem', 
    margin: 0, 
    opacity: 0.9 
  },
  headerRight: { 
    display: 'flex', 
    gap: '20px' 
  },
  headerIcon: { 
    cursor: 'pointer' 
  },
  iconPlaceholder: { 
    display: 'flex', 
    alignItems: 'center' 
  },

  menuBar: {
    display: 'flex',
    alignItems: 'center',
    color: 'Black',
    padding: '0 20px',
    height: '55px',
    width: '100%',
    boxSizing: 'border-box',
    margin: 0,
  },
  hamburgerMenu: { 
    cursor: 'pointer', 
    marginRight: '25px', 
    display: 'flex', 
    alignItems: 'center' 
  },
  hamburgerIcon: { 
    width: '24px', 
    height: '24px', 
    objectFit: 'contain' 
  },
  menuItem: { 
    padding: '0 15px', 
    cursor: 'pointer', 
    fontWeight: '500' 
  },

  // ────────────────────────────────────────────────
  //  SIDEBAR STYLES (both left & right)
  // ────────────────────────────────────────────────
  sidebarOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 2000,
    display: "flex",
    backgroundColor: "rgba(0,0,0,0.4)", // semi-transparent backdrop
  },

  // Left sidebar (existing)
  sidebar: {
    width: "280px",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    backdropFilter: "blur(12px)",
    height: "100%",
    padding: "30px 20px",
    boxShadow: "4px 0 15px rgba(0,0,0,0.5)",
    transform: "translateX(0)", // default visible position
    transition: "transform 0.3s ease-in-out",
  },

  // Right sidebar – key changes here
  rightSidebar: {
    width: "280px",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    backdropFilter: "blur(12px)",
    height: "100%",
    padding: "30px 20px",
    boxShadow: "-4px 0 15px rgba(0,0,0,0.5)",
    borderLeft: "1px solid rgba(255, 255, 255, 0.1)",
    transform: "translateX(100%)", // starts hidden to the right
    transition: "transform 0.3s ease-in-out",
  },

  sidebarHeader: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "20px",
  },
  closeIcon: { 
    cursor: "pointer", 
    color: "#fff",
    fontSize: "28px"
  },
  sidebarMenu: { 
    listStyle: "none", 
    padding: 0,
    margin: 0
  },
  sidebarMenuItem: {
    padding: "15px 0",
    cursor: "pointer",
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
    color: "#fff",
    fontSize: "1.1rem",
    fontWeight: "500",
    transition: "color 0.2s",
  },

  // Optional hover effect for menu items
  sidebarMenuItemHover: {
    color: "#6bbe23"
  },

  overlayBackdrop: {
    flex: 1,
    height: "100%",
    cursor: "pointer",
  },
};